module.exports = __webpack_public_path__ + "static/media/6dbb9b2d-9ac4-4838-815b-e1d614adcdbc.46e0044d.JPG";